//const TxtProblemasObtener = 'Se presentaron problemas al obtener ';
//const TxtProblemasEjecutar = 'Se presentaron problemas ';

export const MensajesGenericos_EN = [
    //buscadores
    {
        'codigo': 'SearchFilterDsc',
        'mensaje': 'Description is required.'
    },
    {
        'codigo': 'SearchFilterClasf',
        'mensaje': 'Classification is required.'
    },
    {
        'codigo': 'SearchAllFilterReq',
        'mensaje': 'All search filters are required.'
    },
    {
        'codigo': 'WarningSelectGradeCode',
        'mensaje': 'You must select the academic grade to perform the search.'
    },
    {
        'codigo': 'WarningSelectCareerCode',
        'mensaje': 'You must select a career to perform the search.'
    },
    {
        'codigo': 'ErrorProgramIdNotEmty',
        'mensaje': 'You must select an academic program to perform the search.'
    },
    {
        'codigo': 'SearchFilterRequired',
        'mensaje': 'You must enter at least one search filter.'
    },
    //fin buscadores
    //base datos
    {
        'codigo': 'ErrorLinkPassExpired',
        'mensaje': 'The password recovery link has expired.'
    },
    {
        'codigo': 'UserInactive',
        'mensaje': 'The user is inactive.'
    },
    {
        'codigo': 'ErrorDeleteConflictRecords',
        'mensaje': 'The record cannot be deleted as it is being used in other processes.'
    },
    //fin base datos
    //errores permisos
    {
        'codigo': 'UnauthorizedAccessModule',
        'mensaje': 'You do not have permissions to access this module.'
    },
    {
        'codigo': 'UnauthorizedAccessOption',
        'mensaje': 'You do not have permissions to access this option.'
    },
    {
        'codigo': 'UnauthorizedActionConsult',
        'mensaje': 'You do not have permissions to consult records in this option.'
    },
    {
        'codigo': 'UnauthorizedActionDelete',
        'mensaje': 'You do not have permissions to delete records in this option.'
    },
    {
        'codigo': 'UnauthorizedActionInsert',
        'mensaje': 'You do not have permissions to insert records in this option.'
    },
    {
        'codigo': 'UnauthorizedActionOption',
        'mensaje': 'You do not have permissions to perform the process in this option.'
    },
    {
        'codigo': 'UnauthorizedActionUpdate',
        'mensaje': 'You do not have permissions to update records in this option.'
    },
    //fin errores permisos
    //mensajes genericos
    {
        'codigo': 'error',
        'mensaje': 'Errors'
    },
    {
        'codigo': 'info',
        'mensaje': 'Information'
    },
    {
        'codigo': 'warning',
        'mensaje': 'Warning'
    },
    {
        'codigo': 'success',
        'mensaje': 'Successful'
    },
    {
        'codigo': 'ok',
        'mensaje': 'Process completed successfully.'
    },
    {
        'codigo': 'insertOk',
        'mensaje': 'Record created successfully.'
    },
    {
        'codigo': 'updateOk',
        'mensaje': 'Record updated successfully.'
    },
    {
        'codigo': 'deleteOk',
        'mensaje': 'Record deleted successfully.'
    },
    {
        'codigo': 'InternalServerError',
        'mensaje': 'There were issues performing the action, please contact the system administrator.'
    },
    {
        'codigo': 'Unauthorized',
        'mensaje': 'Incorrect credentials.'
    },
    {
        'codigo': 'WarningSelectRegistrationCode',
        'mensaje': 'You must select a registration type.'
    },
    {
        'codigo': 'ErrorUpdateFormatFile',
        'mensaje': 'There were issues updating file formats.'
    },
    {
        'codigo': 'ErrorListFormatFile',
        'mensaje': 'There were issues listing file formats.'
    },
    {
        'codigo': 'ErrorDateFormatFI',
        'mensaje': 'You must enter a valid start date.'
    },
    {
        'codigo': 'ErrorDateFormatFF',
        'mensaje': 'You must enter a valid end date.'
    },
    {
        'codigo': 'CodeRequeridoAnno',
        'mensaje': 'The year is required.'
    },
    {
        'codigo': 'CodeRequeridoPeriodo',
        'mensaje': 'The period is required.'
    },
    {
        'codigo': 'CodeRequeridoDescripcion',
        'mensaje': 'Description is required.'
    },
    {
        'codigo': 'CodeRequeridoCode',
        'mensaje': 'The code is required.'
    },
    {
        'codigo': 'CodeRequeridoName',
        'mensaje': 'The name is required.'
    },
    {
        'codigo': 'CodeRequeridoStartTime',
        'mensaje': 'The start time is required.'
    },
    {
        'codigo': 'CodeRequeridoEndTime',
        'mensaje': 'The end time is required.'
    },
    {
        'codigo': 'CodeRequeridoInformacion',
        'mensaje': 'Information is required.'
    },
    {
        'codigo': 'CodeRequeridoCampus',
        'mensaje': 'The campus is required.'
    },
    {
        'codigo': 'ErrorListSedes',
        'mensaje': 'There were issues retrieving the list of campuses.'
    },
    {
        'codigo': 'ErrorRecordIdNotEmpty',
        'mensaje': 'You must select a record.'
    },
    {
        'codigo': 'ErrorValidEmailFormat',
        'mensaje': 'Please enter a valid email address.'
    },
    {
        'codigo': 'ErrorConfirmPassw',
        'mensaje': 'There were issues during the password change process.'
    },
    {
        'codigo': 'ErrorEmailSend',
        'mensaje': 'There were issues sending emails.'
    },
    {
        'codigo': 'ChangePasswOK',
        'mensaje': 'Password change successful.'
    },
    {
        'codigo': 'WarningNoExistenCamposDinamicos',
        'mensaje': 'There are no defined fields for this option.'
    },
    //fin mensajes genericos
    //mensajes pago en linea
    {
        'codigo': 'WarningPagoNoConfirmado',
        'mensaje': 'We could not confirm your payment status. If you completed the payment, please wait a few minutes and try again; if the problem persists, contact the system administrator.'
    },
    {
        'codigo': 'WarningAprobacionAdmisionPendiente',
        'mensaje': 'Your payment was registered successfully, but the admission approval is still pending. Please contact the system administrator to complete it.'
    },
    //mensajes manejo archivos
    {
        'codigo': 'ErrorFile401',
        'mensaje': 'There were issues uploading the file to the server (write permissions), please contact the system administrator.'
    },
    {
        'codigo': 'ErrorFile409',
        'mensaje': 'A file with the same name already exists on the server.'
    },
    {
        'codigo': 'ErrorDataFileNotEmty',
        'mensaje': 'No file data found.'
    },
    {
        'codigo': 'ErrorExtensionFileNotEmty',
        'mensaje': 'There were issues with the file extension.'
    },
    {
        'codigo': 'ErrorFileNotFound',
        'mensaje': 'File not found.'
    },
    {
        'codigo': 'ErrorNameFileNotEmty',
        'mensaje': 'Could not retrieve the file name.'
    },
    {
        'codigo': 'ErrorNotFoundFile',
        'mensaje': 'File not found.'
    },
    {
        'codigo': 'ErrorMimeTypeNotEmty',
        'mensaje': 'There were issues with the file extension.'
    },
    //fin mensajes manejo archivos
    //MENSAJES CORE
    {
        'codigo': 'CantAddPassword',
        'mensaje': 'Issues occurred while resetting the password, please try again.'
    },
    {
        'codigo': 'CantRemovePassword',
        'mensaje': 'Issues occurred while resetting the password, please try again.'
    },
    {
        'codigo': 'ErrorActionNotEmty',
        'mensaje': 'There were issues performing the action, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorActualizarUsuario',
        'mensaje': 'There were issues performing the action, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorAuditLog',
        'mensaje': 'Problems registering audit log.'
    },
    {
        'codigo': 'ErrorCapitalLetter',
        'mensaje': 'Please enter at least one uppercase letter.'
    },
    {
        'codigo': 'ErrorCodLangNotEmty',
        'mensaje': 'There were issues with the language, please try again.'
    },
    {
        'codigo': 'ErrorCompaniaIdNotEmty',
        'mensaje': 'Company data not found.'
    },
    {
        'codigo': 'ErrorCompaniaNotEmty',
        'mensaje': 'Company data not found.'
    },
    {
        'codigo': 'ErrorConfigEmailCompanyNotFound',
        'mensaje': 'Email sending data not found, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorCustomerIdNotEmty',
        'mensaje': 'You must select a CIF.'
    },
    //mensajes pago en linea (invoice inscripcion)
    {
        'codigo': 'ErrorAdmissionIdNotEmty',
        'mensaje': 'The admission could not be identified to process the payment, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorPeriodIdNotEmty',
        'mensaje': 'The academic period could not be identified to process the payment, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorObteniendoInvoice',
        'mensaje': 'There were issues retrieving the enrollment amount, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorDefaultCurrencyNotFound',
        'mensaje': 'The company default currency was not found, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorVirtualUserNotFound',
        'mensaje': 'The enrollment could not be processed due to a system configuration, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorDataAutorization',
        'mensaje': 'Issues retrieving access authorization data, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorDescriptionItemNotEmty',
        'mensaje': 'You must enter a description.'
    },
    {
        'codigo': 'ErrorEmailLongitud',
        'mensaje': 'Email must not exceed 200 characters.'
    },
    {
        'codigo': 'ErrorEmailVacio',
        'mensaje': 'Email cannot be empty.'
    },
    {
        'codigo': 'ErrorExistPasswordHistory',
        'mensaje': 'The new password must not match a previously registered one.'
    },
    {
        'codigo': 'ErrorGetAddressType',
        'mensaje': 'Issues retrieving address types.'
    },
    {
        'codigo': 'ErrorGetCategorySystemCode',
        'mensaje': 'Issues retrieving categories.'
    },
    {
        'codigo': 'ErrorGetCIFType',
        'mensaje': 'Issues retrieving CIF types.'
    },
    {
        'codigo': 'ErrorGetClient',
        'mensaje': 'Issues retrieving CIF data.'
    },
    {
        'codigo': 'ErrorGetClientCivilStates',
        'mensaje': 'Issues retrieving civil status types.'
    },
    {
        'codigo': 'ErrorGetClientGenders',
        'mensaje': 'Issues retrieving gender types.'
    },
    {
        'codigo': 'ErrorGetClientIdentifiers',
        'mensaje': 'Issues retrieving identification types.'
    },
    {
        'codigo': 'ErrorGetCompanyConfig',
        'mensaje': 'Issues retrieving company configuration.'
    },
    {
        'codigo': 'ErrorGetCompanyInfo',
        'mensaje': 'Issues retrieving company information.'
    },
    {
        'codigo': 'ErrorGetCompanyList',
        'mensaje': 'Unable to retrieve the list of companies.'
    },
    {
        'codigo': 'ErrorGetContactType',
        'mensaje': 'Issues retrieving contact types.'
    },
    {
        'codigo': 'ErrorGetCountry',
        'mensaje': 'Issues retrieving the list of countries.'
    },
    {
        'codigo': 'ErrorGetCostumerImage',
        'mensaje': 'Unable to retrieve CIF image.'
    },
    {
        'codigo': 'ErrorGetDateFormat',
        'mensaje': 'Unable to retrieve date formats.'
    },
    {
        'codigo': 'ErrorGetEmailCompanyConfig',
        'mensaje': 'Issues retrieving company email sending data.'
    },
    {
        'codigo': 'ErrorGetProcessFlow',
        'mensaje': 'Unable to retrieve process flow.'
    },
    {
        'codigo': 'ErrorGetLocation1',
        'mensaje': 'Unable to retrieve location list.'
    },
    {
        'codigo': 'ErrorGetLocation2',
        'mensaje': 'Unable to retrieve location list.'
    },
    {
        'codigo': 'ErrorGetLocation3',
        'mensaje': 'Unable to retrieve location list.'
    },
    {
        'codigo': 'ErrorGetLocation4',
        'mensaje': 'Unable to retrieve location list.'
    },
    {
        'codigo': 'ErrorGetPagination',
        'mensaje': 'Issues occurred while performing data pagination.'
    },
    {
        'codigo': 'ErrorGetPoliticaContrasena',
        'mensaje': 'Encountered problems while fetching password policies.'
    },
    {
        'codigo': 'ErrorGetRecoveryPassInfo',
        'mensaje': 'Encountered problems while performing the password recovery process.'
    },
    {
        'codigo': 'ErrorGetUserImage',
        'mensaje': 'Failed to obtain the user image.'
    },
    {
        'codigo': 'ErrorHistoricoContrasena',
        'mensaje': 'Encountered problems while performing the password recovery process.'
    },
    {
        'codigo': 'ErrorIdiomaNotEmty',
        'mensaje': 'Encountered problems while validating the language, please try again.'
    },
    {
        'codigo': 'ErrorListAcaProgram',
        'mensaje': 'Encountered problems while fetching academic programs.'
    },
    {
        'codigo': 'ErrorListAdmissions',
        'mensaje': 'Encountered problems while fetching student admissions.'
    },
    {
        'codigo': 'ErrorListCampus',
        'mensaje': 'Encountered problems while fetching the list of campuses.'
    },
    {
        'codigo': 'ErrorListCareer',
        'mensaje': 'Encountered problems while fetching the list of careers.'
    },
    {
        'codigo': 'ErrorListCourse',
        'mensaje': 'Encountered problems while fetching the list of courses.'
    },
    {
        'codigo': 'ErrorListCursosProgramas',
        'mensaje': 'Encountered problems while fetching the list of courses for the program.'
    },
    {
        'codigo': 'ErrorListPeriodosAca',
        'mensaje': 'Encountered problems while fetching the list of academic periods.'
    },
    {
        'codigo': 'ErrorListRequiredFieldsSec',
        'mensaje': 'Encountered problems while fetching the list of required fields.'
    },
    {
        'codigo': 'ErrorListSystemCode',
        'mensaje': 'Encountered problems while fetching records by system codes.'
    },
    {
        'codigo': 'ErrorLocationId1NotNull',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorLocationId2NotNull',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorLocationId3NotNull',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorLocationId4NotNull',
        'mensaje': 'You must select the location.'
    },
    {
        'codigo': 'ErrorLowercaseLetter',
        'mensaje': 'Please enter at least one lowercase letter.'
    },
    {
        'codigo': 'ErrorMaximumCharacters',
        'mensaje': 'Exceeds the maximum allowed characters.'
    },
    {
        'codigo': 'ErrorMinimumCharacters',
        'mensaje': 'Does not meet the minimum allowed characters.'
    },
    {
        'codigo': 'ErrorModuleNotEmty',
        'mensaje': 'Encountered problems while fetching data from the active module.'
    },
    {
        'codigo': 'ErrorNoExisteUsuario',
        'mensaje': 'The user does not exist.'
    },
    {
        'codigo': 'ErrorNumber',
        'mensaje': 'Please enter at least one number.'
    },
    {
        'codigo': 'ErrorOptionIdNotEmty',
        'mensaje': 'Encountered problems while fetching option data.'
    },
    {
        'codigo': 'ErrorProcessingAction',
        'mensaje': 'Encountered problems while performing the action, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorProfileNotEmty',
        'mensaje': 'Failed to identify the type of CIF.'
    },
    {
        'codigo': 'ErrorDscLongitud100',
        'mensaje': 'Description should not exceed 100 characters.'
    },
    {
        'codigo': 'ErrorDscLongitud200',
        'mensaje': 'Description should not exceed 200 characters.'
    },
    {
        'codigo': 'ErrorReadDynamicFields',
        'mensaje': 'Encountered problems while fetching dynamic fields information.'
    },
    {
        'codigo': 'ErrorRecoveryPassToken',
        'mensaje': 'Encountered problems while validating the password recovery link.'
    },
    {
        'codigo': 'ErrorSaveCustomerImage',
        'mensaje': 'Encountered problems while saving the image.'
    },
    {
        'codigo': 'ErrorSaveDinamycFields',
        'mensaje': 'Encountered problems while saving entered information.'
    },
    {
        'codigo': 'ErrorSaveLogoutLog',
        'mensaje': 'There were issues with the audit logs.'
    },
    {
        'codigo': 'ErrorSaveLoginLog',
        'mensaje': 'There were issues with the audit logs.'
    },
    {
        'codigo': 'ErrorSaveUserImage',
        'mensaje': 'Encountered problems while saving the image.'
    },
    {
        'codigo': 'ErrorSeccionCodeLongitud',
        'mensaje': 'Encountered problems while validating the section of required fields.'
    },
    {
        'codigo': 'ErrorSeccionCodeNotEmty',
        'mensaje': 'Encountered problems while validating the section of required fields.'
    },
    {
        'codigo': 'ErrorSetAccessModule',
        'mensaje': 'Encountered problems while accessing the module.'
    },
    {
        'codigo': 'ErrorSetAccessOption',
        'mensaje': 'Encountered problems while accessing the option.'
    },
    {
        'codigo': 'ErrorSetLanguageUser',
        'mensaje': 'Encountered problems while changing the language.'
    },
    {
        'codigo': 'ErrorSpecialCharacter',
        'mensaje': 'You must enter at least one special character.'
    },
    {
        'codigo': 'ErrorSystemCodeIdNotEmty',
        'mensaje': 'You must select the system code type.'
    },
    {
        'codigo': 'ErrorTypesSystemCode',
        'mensaje': 'Encountered problems while obtaining system code types.'
    },
    {
        'codigo': 'ErrorUrlBaseNotEmty',
        'mensaje': 'Issues with the Class Limitless configuration, please contact the system administrator.'
    },
    {
        'codigo': 'ErrorUserAutorization',
        'mensaje': 'Encountered problems while obtaining user permissions.'
    },
    {
        'codigo': 'ErrorUsuarioNotEmty',
        'mensaje': 'User data not found.'
    },
    {
        'codigo': 'ErrorValidatingAccessModule',
        'mensaje': 'Encountered problems while validating access to the module.'
    },
    {
        'codigo': 'ErrorValidatingAccessOption',
        'mensaje': 'Encountered problems while validating access to the option.'
    },
    {
        'codigo': 'ErrorValidatingUserAction',
        'mensaje': 'Encountered problems while validating user permissions.'
    },
    {
        'codigo': 'ErrorVowel',
        'mensaje': 'You must enter at least one vowel.'
    },
    {
        'codigo': 'FailedToValidate',
        'mensaje': 'Encountered problems while performing validation processes.'
    },
    {
        'codigo': 'SystemCodeErrorInsert',
        'mensaje': 'Encountered problems while inserting the record.'
    },
    {
        'codigo': 'ErrorUserNameNotEmty',
        'mensaje': 'Empty username.'
    },
    //mensajeria
    {
        'codigo': 'ErrorMessageList',
        'mensaje': 'Encountered problems while fetching the list of messages.'
    },
    {
        'codigo': 'ErrorNewMessage',
        'mensaje': 'Encountered problems while sending the message.'
    },
    {
        'codigo': 'ErrorRepplyMessage',
        'mensaje': 'Encountered problems while sending the message.'
    },
    {
        'codigo': 'ErrorDeleteMessage',
        'mensaje': 'Encountered problems while deleting the message.'
    },
    {
        'codigo': 'ErrorDeleteMulMessage',
        'mensaje': 'Encountered problems while deleting the messages.'
    },
    {
        'codigo': 'ErrorMessageDetail',
        'mensaje': 'Encountered problems while fetching the message detail.'
    },
    {
        'codigo': 'ErrorReadMessage',
        'mensaje': 'There were problems setting the message as read.'
    },
    {
        'codigo': 'ErrorUnReadMessage',
        'mensaje': 'There were problems setting the message as unread.'
    },
    {
        'codigo': 'ErrorUnReadMulMessage',
        'mensaje': 'There were problems setting the messages as unread.'
    },
    {
        'codigo': 'ErrorRecipientMessageList',
        'mensaje': 'There were problems fetching the recipient list.'
    },
    {
        'codigo': 'ErrorAttachmentsMessageList',
        'mensaje': 'There were problems loading the attached file.'
    },
    {
        'codigo': 'ErrorRecipientList',
        'mensaje': 'There were problems fetching the recipient list.'
    },
    {
        'codigo': 'ErrorReadMulMessage',
        'mensaje': 'There were problems setting the messages as read.'
    },
    {
        'codigo': 'ErrorMessageIdNotEmpty',
        'mensaje': 'There were problems fetching message data.'
    },
    {
        'codigo': 'ErrorDestinataryNotNull',
        'mensaje': 'There were problems fetching recipient data.'
    },
    {
        'codigo': 'ErrorSubjectNotNull',
        'mensaje': 'You must enter the message subject.'
    },
    {
        'codigo': 'ErrorFilterDscNotEmpty',
        'mensaje': 'You must enter a description.'
    },
    {
        'codigo': 'ErrorRemitentNotNull',
        'mensaje': 'There were problems fetching sender data.'
    },
    {
        'codigo': 'ErrorMessageListNotEmpty',
        'mensaje': 'You must select at least one message from the list.'
    },
    {
        'codigo': 'ErrorReceiverTypeNotEmpty',
        'mensaje': 'There were problems fetching recipient data.'
    },
    //fin mensajeria
    {
        'codigo': 'ErrorGetBaseCurrency',
        'mensaje': 'There were problems fetching the company currency.'
    },
    {
        'codigo': 'ErrorObtenerImagen',
        'mensaje': 'There were problems fetching the image.'
    },
    {
        'codigo': 'ErrorCIFTypeNotEmpty',
        'mensaje': 'The CIF type was not found.'
    },
    {
        'codigo': 'ErrorImageNameNotEmpty',
        'mensaje': 'The image name was not found.'
    },
    {
        'codigo': 'ErrorElementIdNotEmpty',
        'mensaje': 'There were problems identifying the record.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'File format (extension) not allowed.'
    },
    {
        'codigo': 'ErrorActivoCampana',
        'mensaje': 'There were problems fetching data update campaigns.'
    },
    {
        'codigo': 'ErrorCampanaFinalizado',
        'mensaje': 'There were problems updating data update campaigns.'
    },
    {
        'codigo': 'ErrorActualizarDatosSeccion',
        'mensaje': 'There were problems fetching profile data section.'
    },
    {
        'codigo': 'ErrorRequiredFields',
        'mensaje': 'There are mandatory fields (*) with pending information.'
    },
    //FIN MENSAJES CORE
    //Cambio clave
    {
        'codigo': 'ErrorClaveActualVacia',
        'mensaje': 'You must enter your current password.'
    },
    {
        'codigo': 'ErrorNuevaClaveVacia',
        'mensaje': 'You must enter your new password.'
    },
    {
        'codigo': 'ErrorConfirmClaveValidar',
        'mensaje': 'The new password does not match the confirmation.'
    },
    //Cambio clave
]